import defaultChart from './PDFBaseChart';
/* eslint-disable no-param-reassign */
export function createChart(
    metric,
    options
) {
    const template = defaultChart(metric, options);
    const { colour } = options;
    template.chart = {
        // border: { colour: '#00ff00' },
        chart: {
            // border: { colour: '#ff0000' },
            ...template.chart,
            w: 'w-3-1/4',
            h: 'h-0-7/16',
        },
        val: metric.value && {
            display: 'inline',
            ml: 5,
            mt: -5,
            text: `${metric.format(metric.value)}${metric.valueUnits}`,
            font: { weight: 'bold', size: 'xl', colour },
        }
    };
    return template;
}

export default (metric, template) => {
    createChart(metric, template);
    return template;
};
